module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M18 6.138V4h3.02c.552 0 .98-.448.98-1V2c0-1.106-.876-2-1.98-2h-8C10.914 0 10 .894 10 2v1c0 .552.466 1 1.02 1H14v2.138C6 7.124.01 11.842.01 20c0 1.106.904 2 2.01 2H14v6H2.02C.914 28 0 28.894 0 30v1c0 .552.466 1 1.02 1h30c.552 0 .98-.448.98-1v-1c0-1.106-.876-2-1.98-2H18v-6h12.02a1.99 1.99 0 0 0 1.99-2C32.01 11.842 26 7.124 18 6.138z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/bell-3.js
// module id = 1010
// module chunks = 14